export * from './cpf/cpf.pipe.module';
export * from './payment-method/payment-method.pipe.module';
export * from './phone/phone.pipe.module';
export * from './address/address.pipe.module';
export * from './filter/filter.pipe.module';
export * from './attendance/attendance.pipe.module';
export * from './payments-available/payments-available.module';
export * from './sanitize-html/sanitize.pipe.module';
